import React, { useEffect, useState } from "react";
import { MessageType, Product } from "../constants";
import "../modal.css";
import HealthPlanFeaturesPopup from "./Health/PlanFeaturesPopup";
import TravelPlanFeaturesPopup from "./Travel/PlanFeaturesPopup";
export default function PlanFeaturesPopup({ message, closePlanFeaturePopup, productId }) {
    const [openModal, setOpenModal] = useState("")
    const [content, setMessageContent] = useState("")
    // const content = JSON.parse(message.content)

    useEffect(() => {
        console.log(message)
        setOpenModal("open")
        if (message && message.content) {
            setMessageContent(JSON.parse(message.content))
        }
    }, [message])



    return (
        <>
            {productId === Product.Health ?
                <HealthPlanFeaturesPopup
                    content={content}
                    closePlanFeaturePopup={closePlanFeaturePopup}
                    message={message}
                    openModal={openModal}
                />
                : null}
            {productId === Product.Travel ?
                <TravelPlanFeaturesPopup
                    content={content}
                    closePlanFeaturePopup={closePlanFeaturePopup}
                    message={message}
                    openModal={openModal}
                />
                : null}
        </>
    );
}
